<template>
  <div class="stage-setting-container">
    <div class="event-properties-item">
      <div class="event-label">背景颜色</div>
      <div>
        <el-color-picker
          v-model="bgColor"
          size="mini"
          :show-alpha="true"
          :popper-class="'popper-color-prop'"
        ></el-color-picker>
      </div>
    </div>
    <div class="event-properties-item">
      <div class="event-label">背景图片</div>
      <div>
        <input type="file" @change="changeFile"/>
      </div>
      <div>
        <el-button @click="clearBkImage" size="mini">清除背景图片</el-button>
      </div>
    </div>
    <div class="event-properties-item">
      <div class="event-label">打开网格</div>
      <div>
        <el-switch
          v-model="grid"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
    </div>
    <div class="event-properties-item">
      <div class="event-label">网格颜色</div>
      <div>
        <el-color-picker
          v-model="gridColor"
          size="mini"
          :show-alpha="true"
          :popper-class="'popper-color-prop'"
        ></el-color-picker>
      </div>
    </div>
    <div class="event-properties-item">
      <div class="event-label">初始化模块</div>
      <div>
        <el-button size="mini" @click="changeModule">选择模块</el-button>
        <el-button size="mini" @click="clearModule">清除模块</el-button>
      </div>
    </div>
    <div class="event-properties-item" v-if="initJsName">
      <div class="event-label">已选初始化模块</div>
      <div>
        {{ initJsName | joinArr }}
      </div>
    </div>
    <FunctionComponent
      :checkbox="true"
      :show.sync="showFunctionsList"
      :checkedNames="checkedNames"
      @change="changeFunction"
    ></FunctionComponent>
  </div>
</template>
<script>
import { readFile } from "xlsx";
import FunctionComponent from "./event/function.vue";
export default {
  components: { FunctionComponent },
  data() {
    return {
      bgColor: "",
      grid: false,
      gridColor: "",
      fileList: [],
      showFunctionsList: false,
      initJsName: null,
      checkedNames: [],
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.initJsName = this.topo.store.data.initJsName;
    if(this.initJsName){
      this.checkedNames = this.initJsName.split(",");
    }
    
    this.init();
  },
  destroyed() {
    this.saveConfig();
  },
  filters: {
    joinArr(arr) {
      if (Array.isArray(arr)) {
        return arr.join(",");
      }
      return arr;
    },
  },
  methods: {
    init() {
      let stageCanvas = this.topo.stageCanvas;
      if (!stageCanvas) return;
      let options = stageCanvas.getOptions();
      this.gridColor = this.topo.store.data.gridColor ?? options.gridColor;
      this.bgColor = this.topo.store.data.background ?? options.background;
      this.grid = this.topo.store.data.grid ?? options.grid;
    },
    // 显示初始化列表
    changeModule() {
      this.showFunctionsList = true;
    },
    // 清除初始化模块
    clearModule() {
      this.topo.clearInitJs();
      this.initJsName = "";
    },
    saveConfig() {
      let stageCanvas = this.topo.stageCanvas;
      if (!stageCanvas) return;
      this.topo.store.data.background = this.bgColor;
      this.topo.store.data.grid = this.grid;
      this.topo.store.data.gridColor = this.gridColor;
      stageCanvas.setGrid({
        gird: this.grid,
        gridColor: this.gridColor,
      });
      stageCanvas.render();
    },
    // 选择初始化模块函数
    changeFunction(func) {
      let funcs = [];
      func.forEach((element) => {
        funcs.push(element.name);
      });
      this.topo.setInitJs(funcs);
      this.initJsName = funcs;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    changeFile(evt) {
      let file = evt.target.files[0];
      let that = this;
      if (file) {
        let reader = new FileReader();
        reader.onload = function (event) {
          const image = event.target.result;
          that.topo.stageCanvas.setBackgroundImage(image)
        };
        reader.readAsDataURL(file);
      }
    },
    clearBkImage(){
      this.topo.stageCanvas.setBackgroundImage('')
    }
  },
};
</script>
<style lang="scss" scoped>
.stage-setting-container {
  .event-properties-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .event-label {
      width: 120px;
    }
  }
}
</style>